import * as React from 'react'
import { useState } from 'react'

import { Button } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import TextField from 'modules/core/components/TextField'
import i18n from 'modules/core/lib/i18n'

import copyUrl from '../utils/copyUrl'

interface Props {
  onClose: () => void
  moduleTitle: string
  moduleUrl: string
}

const ShareLinkModal = (props: Props) => {
  const { onClose, moduleTitle, moduleUrl } = props
  const [isSaved, setIsSaved] = useState(false)

  return (
    <Modal
      illustration="URL"
      title={i18n.t('marketplace.modules.contact.share_title', {
        module_name: moduleTitle,
      })}
      description={i18n.t('marketplace.modules.sharing_area.description', {
        module_name: moduleTitle,
      })}
      onClose={onClose}
      footer={
        <>
          <Button
            type="secondary"
            onClick={() => {
              onClose()
            }}
          >
            {i18n.t('marketplace.modules.contact.cancel')}
          </Button>
          <Button
            type="primary"
            onClick={() => {
              copyUrl(setIsSaved, moduleUrl)
            }}
          >
            {isSaved
              ? i18n.t('marketplace.modules.sharing_area.copied')
              : i18n.t('marketplace.modules.sharing_area.copy')}
          </Button>
        </>
      }
    >
      <div>
        <TextField
          readonly
          value={moduleUrl}
          label={i18n.t('marketplace.modules.sharing_area.label')}
          showEllipsis
        />
      </div>
    </Modal>
  )
}

export default ShareLinkModal
